import { inject, Pipe, PipeTransform } from '@angular/core';
import { B2BService } from '@api/services/b-2-b.service';
import { LoadData } from '@api/models/B2bService/Contract/load-data';
import { LocalStorage } from '@core/storage/local-storage';
import { StorageKeys } from '@core/storage/storage.keys';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AvailableLanguage } from '@core/localization/available-language';
import { LanguageState } from '@core/localization/language.state';


@Pipe({
    name: 'urlLoadReport',
    standalone: true,
})
export class UrlLoadReportPipe implements PipeTransform {
    @LocalStorage(StorageKeys.Access)
    protected token: string;

    readonly #languageState: LanguageState = inject(LanguageState);

    public transform(value: LoadData): Observable<string> {
        return this.makeReportUrl(value.flId, value.fileName);
    }

    private makeReportUrl(flId: number, fileName: string): Observable<string> {
        return this.#languageState.language$.pipe(
            map((language: AvailableLanguage) =>
                B2BService.ApiB2BListLoadResultGetPath + '?' +
                'lang=' + language + '&' +
                'errFlg=' + String(1) + '&' +
                'flId=' + String(flId) + '&' +
                'fileName=' + String(fileName) + '&' +
                'token=' + this.token),
        );
    }
}
